<template>
  <div class="border-comp2">
    <div class="comp2-content" :class="customClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BorderComp2',
  props: {
    customClass: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="scss">
.border-comp2 {
  height: 100%;
  padding: 2px;
  background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
    url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
    url('~@/assets/image/linelight.png');
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: top left, top right, bottom left, bottom right, center -5px;
  .comp2-content {
    height: 100%;
    box-sizing: border-box;
    border: 1px solid var(--device-comp-border-color, #6076ad);
  }
}
</style>
